import clsx from 'clsx';

import Icon from '@components/icon/Icon';
import { DEFAULT_PLACEHOLDER } from '@constants/generic';

import {
  getSourceAvatarColor,
  getSourceIconName,
  getSourceInitials
} from '../../utils/sourceAvatar';

interface SourceAvatarProps {
  name: string;
  className?: string;
}

const SourceAvatar = ({ name, className }: SourceAvatarProps) => {
  const iconName = getSourceIconName(name);

  if (iconName) {
    return (
      <Icon name={iconName} size="26" className={clsx('shrink-0', className)} />
    );
  }

  const color = getSourceAvatarColor(name);

  return (
    <div
      className={clsx(
        'flex size-26 shrink-0 items-center justify-center rounded-[4px]',
        'text-xs font-semibold',
        color.bg,
        color.text,
        className
      )}
      aria-hidden
    >
      {getSourceInitials(name) || DEFAULT_PLACEHOLDER}
    </div>
  );
};

export default SourceAvatar;
